import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import * as userDataActions from '../../../actions/userDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class Link extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            userData: this.props.userData,
            status: objectConstants.STATUS_NOT_STARTED,
            locale: appHelper.getLocalData(this.props.screenObject),
            showProgressionButton: false,
            link: {},
            screenStatus:"",
            isResourceObject: appHelper.isDefined(this.props.callbacks.checkIsResourceScreen) && this.props.callbacks.checkIsResourceScreen(),
            allowScroll: appHelper.allowScroll(this.props.callbacks.getBiteId(),this.props.callbacks.getScreenId(),this.props.screenObject.asset_id),
            continue_label: appHelper.getLocaleString("continue_label")
        };
        this.getAssets = this.getAssets.bind(this);
        this.show = this.show.bind(this);
        this.handleProgression = this.handleProgression.bind(this);
        this.onOpen = this.onOpen.bind(this);
        this.setClass = this.setClass.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.disableProgression = this.disableProgression.bind(this);
        this.onProgressionBtnClicked = this.onProgressionBtnClicked.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.getScreenStatus = this.getScreenStatus.bind(this);
        this.onRendered = this.onRendered.bind(this);
    }

    componentDidMount() {
        this.getAssets();
        this.getScreenStatus();
        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
        }


    }

    componentWillReceiveProps(nextProps) {
        if(this.state.userData !== nextProps.userData){
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }
        if(this.state.lang !== nextProps.lang){
            let link = appHelper.getLinkAsset(this.state.screenObject);
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                link: appHelper.isDefined(link.locale) ? appHelper.getLocalData(link) : link,
                continue_label: appHelper.getLocaleString("continue_label")
            });
        }
    }

    componentDidUpdate(){
        if(this.state.userDataUpdated){
            this.getObjectStatus();
        }
    }

    getScreenStatus(){
        let screenStatus = this.props.callbacks.getScreenStatus();
        this.setState({
            screenStatus: screenStatus,
            status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
        });
    }

    getObjectStatus() {
        this.setState({userDataUpdated: false});
        if(this.state.screenStatus === objectConstants.STATUS_COMPLETE){
            this.onComplete();
        }else{
            let objectUserData = {};
            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                let subScreenParent = this.props.callbacks.getSubScreenParent();
                let screen_id = this.props.callbacks.getScreenId();
                if (appHelper.isDefined(subScreenParent)) {
                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
                }else if(this.state.isResourceObject){
                    objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
                }else{
                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
                }
            }

            if(!this.state.screenObject.required_for_completion || objectUserData.status === objectConstants.STATUS_COMPLETE){
                this.setState({status: objectConstants.STATUS_COMPLETE});
                this.onComplete();
            }

        }
    }

    getAssets() {
        let link = appHelper.getLinkAsset(this.state.screenObject);
        this.setState({link: appHelper.isDefined(link.locale) ? appHelper.getLocalData(link) : link });
        this.show();
    }

    show() {
        let fileRef = this.refs[`link_${this.state.screenObject.asset_id}`];
        if (appHelper.isDefined(fileRef)) {
            TweenLite.set(fileRef, {opacity: 1, height: "auto"});
            TweenLite.from(fileRef, objectConstants.SHOW_PANEL_DURATION, {
                height: 0,
                opacity: 0,
                ease: Expo.easeInOut
            }).eventCallback("onComplete", this.onRendered);
        }
    }

    onRendered(){
        if(this.state.isResourceObject){
            this.props.callbacks.onObjectRendered();
        }
        this.getObjectStatus();
    }

    scrollToTop() {
        if(this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
            let question = this.refs[`link_${this.state.screenObject.asset_id}`];
            let scrollTo = this.props.callbacks.scrollTo;
            setTimeout(function () {
                if (appHelper.isDefined(scrollTo)) {
                    scrollTo(question.offsetTop);
                }
            }, objectConstants.SCROLL_TO);
        }
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    onOpen() {
        if (this.state.status !== objectConstants.STATUS_COMPLETE) {
            this.setState({status: objectConstants.STATUS_COMPLETE});
            this.onComplete();
        }
    }

    setClass() {
        if (this.state.status === objectConstants.STATUS_COMPLETE) {
            return "complete";
        } else {
            return "not-started";
        }
    }

    onComplete() {
        this.setState({checkComplete: false});
        let hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
        if(appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)){
            if(!hasNextObject && !this.state.isResourceObject) {
                this.handleProgression();
                this.enableProgression();
            }else if(!hasNextObject && this.state.isResourceObject){
                this.handleProgression();
            }else if(this.state.isResourceObject) {
                this.handleProgression();
            }else{
                this.enableProgression();
            }

        }else{
            this.handleProgression();
        }
        this.scrollToTop();
    }

    enableProgression() {
        if (!this.props.callbacks.isReviewMode()) {
            this.setState({showProgressionButton: true});
        }
    }

    disableProgression() {
        this.setState({showProgressionButton: false});
    }

    handleProgression() {
        let progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
        let progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
        let progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
        let completionData = {
            progression: progressionRule,
            progressionType: progressionType,
            progressionGoToId: progressionGoToId,
            asset_id: this.state.screenObject.asset_id,
            status: objectConstants.STATUS_COMPLETE,
            showProgressionButton: false,
            asset_type_code: this.state.screenObject.asset_type_code,
            navigateToNextScreen: !this.state.isResourceObject && appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
            index: this.props.index
        };

        this.props.callbacks.onObjectComplete(completionData);
        //t

    }

    onProgressionBtnClicked(){
        this.setState({showProgressionButton: false});
        if(this.props.callbacks.hasNextObject(this.props.index) || this.state.isResourceObject){
            this.handleProgression();
        }else{
            this.props.callbacks.navigateToNextScreen();
        }
    }

    render() {
        return (
            <div className="object-container" ref={`link_${this.state.screenObject.asset_id}`}>
                <div className={`document-panel link ${this.setClass()}`}>
                    <div className="flex-item">
                        <div className="document-header">
                            <div className={`link-title link ${this.setClass()}`}>
                                <a href={this.state.link.src}
                                   target="_blank"
                                   onClick={this.onOpen}
                                   tabIndex="-1"
                                   dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
                            </div>
                        </div>
                        <div className="link-sub-title">
                            <a href={this.state.link.src}
                               target="_blank"
                               id={`link_url_${this.state.screenObject.asset_id}`}
                               onClick={this.onOpen}
                               tabIndex={0}
                               dangerouslySetInnerHTML={{__html: this.state.link.src}}/>
                        </div>
                        {appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null  && this.state.locale.description.length > 0
                            ?
                            <div className="document-description"
                                 dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                            : null
                        }
                    </div>
                </div>
                {this.state.showProgressionButton
                    ? <Button label={this.state.continue_label}
                              id={`${this.state.screenObject}_button`}
                              onClick={this.onProgressionBtnClicked}/>
                    : null
                }
            </div>
        );
    }
}
/*<div className="flex-item">
                        <div className={`thumbnail-container link ${this.setClass()}`}>
                            <img src={this.getImagePath(this.state.link.thumbnail)}/>
                        </div>
                    </div>
*/
Link.propTypes = {
    screenObject: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    index: PropTypes.number,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

Link.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, userDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Link);



/** WEBPACK FOOTER **
 ** ./src/components/objects/link/Link.js
 **/